export const SENTRY_RELEASE = '82cdf640921c70537e6d3ad29e2235cf3865f77f';
